import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-06-23
 * @brief SEI 리포트 컴포넌트
 *
 ********************************************************************/
import { useRecoilValue } from "recoil";
import { reportTypeState } from "../../../../recoil/assessmentState";
import ReportTotalResult from "@components/dashBoard/report/result/ReportToTalResult";
import ReportCheckHeader from "./ReportCheckHeader";
import ReportResult from "./ReportResult";
function ReportCheckMain(props) {
    // recoil
    const report = useRecoilValue(reportTypeState);
    // porps
    const { handleOpenPop } = props;
    return (_jsxs(_Fragment, { children: [_jsx(ReportCheckHeader, {}), report.smenu == "assessment" && report.assessmentId > 0 ? (_jsx(ReportResult, { handleOpenPop: handleOpenPop })) : (report.smenu == "total" && report.totalInfo.totalId > 0 && _jsx(ReportTotalResult, { handleOpenPop: handleOpenPop }))] }));
}
export default ReportCheckMain;
